import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="-1 -1 26 24" fill="#FFF">
    <path d="M6 17c-3.3 0-6-2.7-6-6s2.7-6 6-6c2.5 0 4.8 1.6 5.7 4H19c.1 0 .3.1.4.1l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5c-.1.1-.3.2-.4.2h-1.3l-.9.9c-.2.2-.5.2-.7 0l-.8-.9h-.6l-.9.9c-.2.2-.5.2-.7 0l-.8-.9h-.6c-.9 2.4-3.2 4-5.7 4zM6 6c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.2 0 4.2-1.5 4.8-3.6.1-.2.3-.4.5-.4h1.2c.1 0 .3.1.4.1l.6.6.6-.6c.1-.1.2-.1.4-.1h1c.1 0 .3.1.4.1l.6.6.6-.6c.1-.1.2-.1.4-.1h1.3l1-1-1-1h-7.5c-.2 0-.4-.1-.5-.4C10.2 7.5 8.2 6 6 6z" />
    <path d="M4 13c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM23.5 22h-13c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5s.5.2.5.5V21h12V1H11v3c0 .3-.2.5-.5.5S10 4.3 10 4V.5c0-.3.2-.5.5-.5h13c.3 0 .5.2.5.5v21c0 .3-.2.5-.5.5z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-user-oauth.es6.js